<template>
  <div class="animated fadeIn all-images main-div">
    <vLoading v-if="vLoading" />
    <div v-if="loaded">
      <v-row class="pt-1">
        <v-col sm="6" cols="12">
          <div class="pt-1 fs-small">
            <router-link to="/map" class="no-underline">
              <span class="c-primary"> انتخاب استان </span>
            </router-link>
            <v-icon>mdi-chevron-left</v-icon>
            <span @click="goToMap('state')" class="c-grey pointer">
              استان {{ companyInfo.state }}
            </span>
            <v-icon>mdi-chevron-left</v-icon>
            <span @click="goToMap('company')" class="c-grey pointer">
              شرکت‌ها
            </span>
            <v-icon>mdi-chevron-left</v-icon>
            <span @click="goToProfile()" class="c-grey pointer">
              {{ companyInfo.name }}
            </span>
            <v-icon>mdi-chevron-left</v-icon>
            <span class="c-grey font-weight-bold"> گالری تصاویر </span>
          </div>
        </v-col>
        <v-col sm="6" cols="12" class="text-left">
          <v-btn
            @click="goToMap('state')"
            class="bc-primary text-white no-underline"
            ><span class="c-light">بازگشت به نقشه</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row class="">
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <v-card class="common-card company-card">
            <v-row class="uni-header">
              <v-col cols="12" class="d-flex flex-column flex-sm-row">
                <div class="view-imageBox">
                  <img
                    :src="
                      companyInfo.avatar
                        ? companyInfo.avatar
                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                    "
                  />
                </div>
                <div class="description-box px-5">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    {{ companyInfo.name }}
                  </h5>
                  <p v-if="companyInfo.description" class="c-grey fs-medium">
                    {{
                      companyInfo.description.length > 180
                        ? companyInfo.description.slice(0, 180) + "..."
                        : companyInfo.description
                    }}
                  </p>
                  <p v-else class="c-grey fs-small">
                    توضیحی برای شرکت ثبت نشده است.
                  </p>
                </div>
              </v-col>
            </v-row>
            <div v-if="companyInfo.description.length > 220" class="text-left">
              <v-btn
                class="seeMore-btn"
                @click="openSeeMoreModal('description')"
                text
              >
                <span class="c-primary">مشاهده بیشتر</span>
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <v-card class="common-card card-height">
            <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس شرکت</h5>
            <div class="pt-2 c-grey">
              <v-icon>$Location</v-icon>
              <span class="fs-medium">
                نشانی شرکت:
                {{
                  companyInfo.state +
                  ", " +
                  companyInfo.city +
                  (companyInfo.city ? ", " : "")
                }}
                {{ companyInfo.address ? companyInfo.address : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2">$Phone</v-icon>
              <span class="fs-medium">
                تلفن‌های تماس :
                {{ companyInfo.tel ? companyInfo.tel : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2">$Email</v-icon>
              <span class="fs-medium">
                ایمیل :
                {{ companyInfo.email ? companyInfo.email : "--" }}
              </span>
            </div>
            <div class="pt-4 c-grey">
              <v-icon class="pe-2">$Url</v-icon>
              <span class="fs-medium" v-if="companyInfo.website">
                آدرس‌‌ تارنما:
                <a :href="checkWebsite()" target="_blank">{{
                  companyInfo.website
                }}</a>
              </span>
              <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <div class="mt-4">
        <v-card class="common-card card-height">
          <v-row>
            <v-col class="pb-0">
              <h4 class="fs-xxlarge c-dark pt-2">گالری تصاویر</h4>
            </v-col>
            <v-col sm="5" cols="12" class="pb-0">
              <v-text-field
                rounded
                filled
                class="search-box mt-2 mt-sm-0"
                placeholder="جستجو در عناوین تصاویر..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="loaded" class="mt-0">
            <v-col v-if="!computedImage.length">
              <div class="no-content">
                <hr />
                تصویری برای این شرکت به ثبت نرسیده است.
                <hr />
              </div>
            </v-col>
            <v-col
              md="4"
              sm="6"
              cols="12"
              v-else
              v-for="(item, index) in computedImage"
              :key="index"
            >
              <div class="px-4">
                <div class="image-box">
                  <v-img :src="item.url"></v-img>
                  <div class="image-title">
                    {{
                      item.title.length > 30
                        ? item.title.slice(0, 30) + "..."
                        : item.title
                    }}
                  </div>
                  <div class="hover-box" @click="showBig(item)">
                    <div>
                      <v-icon>$zoomIcon</v-icon>
                      <p class="fs-large mt-2 mb-0">مشاهده</p>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-dialog v-model="showImage" max-width="590">
          <v-card class="modal-card">
            <v-container class="text-center">
              <div class="image-box">
                <img :src="selected.url" />
              </div>
              <div class="px-1 mt-4 fs-medium text-right">
                {{ selected.title }}
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="seeMoreModal" width="600">
          <v-card class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    {{ companyInfo.title }}
                  </h5>
                </v-col>
                <v-col class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>

              <p class="c-grey fs-medium" style="line-height: 30px">
                {{ companyInfo.description }}
              </p>
            </v-container>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: [],
      loaded: false,
      filter: "",
      selected: {},
      showImage: false,
      companyInfo: {},
      seeMoreModal: false,
      vLoading: false,
    };
  },
  methods: {
    openSeeMoreModal() {
      this.seeMoreModal = true;
    },
    goToMap(to) {
      this.$router.push("/map");
      if (to == "state") {
        localStorage.setItem("state", this.companyInfo.state);
        localStorage.setItem("stateId", this.companyInfo.stateId);
      } else if (to == "company") {
        localStorage.setItem("state", this.companyInfo.state);
        localStorage.setItem("stateId", this.companyInfo.stateId);
        localStorage.setItem("item", "company");
      }
    },
    goToProfile() {
      this.$router.push("/companyProfile/" + this.$route.params.id);
    },
    getInfo() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/company/gallery",
          {
            companyId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companyInfo = res.data;
          this.vLoading = false;
          this.loaded = true;
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    showBig(item) {
      this.selected = item;
      this.showImage = true;
    },
    checkWebsite() {
      if (
        this.companyInfo.website.indexOf("http://") == 0 ||
        this.companyInfo.website.indexOf("https://") == 0
      ) {
        return this.companyInfo.website;
      } else {
        return "//" + this.companyInfo.website;
      }
    },
  },
  computed: {
    computedImage() {
      let filtered;
      filtered = this.companyInfo.gallery.filter((x) =>
        x.title.includes(this.filter)
      );
      return filtered;
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
</style>
